import React from 'react';

import { Modal } from '@qwealth/qcore';
import { Partner } from '@qwealth/qdata';

import { Kyp, KypFormType } from 'data/models/Kyp';
import KypForm from '../KypForm/KypForm';
import KypReviewForm from '../KypForm/KypReviewForm';
import KypFilterSection from '../KypFilters/KypFilters';

const modalTypeTitleMap: Record<string, string> = {
  create: 'Create Product',
  edit: 'Edit Existing Product',
  review: 'Review Product',
  filter: 'Filter Products',
};

interface KypModalProps {
  kyp?: Kyp;
  partners: Partner[];
  show: boolean;
  type: KypFormType;
  onClose: () => void;
}

const KypModal: React.FC<KypModalProps> = ({ kyp, partners, show, type, onClose }) => {
  const modalTitle = modalTypeTitleMap[type];

  return (
    <Modal onClose={() => onClose()} show={show} title={modalTitle} size={type === 'filter' ? '' : 'xl'}>
      <Modal.Body>
        {(type === 'create' || type === 'edit') && <KypForm partners={partners} onClose={onClose} kyp={kyp} formType={type} />}
        {type === 'review' && kyp !== undefined && <KypReviewForm kyp={kyp} onClose={onClose} />}
        {type === 'filter' && <KypFilterSection />}
      </Modal.Body>
    </Modal>
  );
};

export default KypModal;
